import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import Icons from 'components/Icons';
import { track } from 'common/analytics';

import classes from './TopBar.module.css';

function TopBar({ title, leftComponent, rightComponent }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useParams();

  if (!leftComponent) {
    leftComponent = (
      <button
        type="button"
        className="btn"
        onClick={() => {
          if (location.pathname.includes('/daily')) {
            navigate(`/${language}/`, { replace: true });
          } else {
            navigate(-1);
          }
          track.backButtonClick(language);
        }}
      >
        <Icons.Back />
      </button>
    );
  }

  if (!rightComponent) {
    rightComponent = (
      <div className={classes.topBarRightPlaceholder}>&nbsp;</div>
    );
  }

  return (
    <div className={classes.topBarWrapper}>
      <div className={classes.topBar}>
        {leftComponent}
        {title}
        {rightComponent}
      </div>
    </div>
  );
}

export default TopBar;
